import type { ReactNode } from 'react';

export const symbol_nest_cam_magnet_mount: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M930-318q-28.87 0-49.44-20.56Q860-359.13 860-388v-160q0-29 20.56-49.5Q901.13-618 930-618h30v300h-30Zm-662.75 92.5Q256-230 248-238L50-435q-9-8.96-13.5-19.78Q32-465.61 32-476.8q0-11.2 4.5-22.7T49-520l129-130q29-29 65.5-44t76.5-15q84 0 142 58t58 142q0 40-15 76.5T461-367L332-238q-8 8-19.5 12.5t-22.75 4.5q-11.25 0-22.5-4.5ZM319.83-649q-26.83 0-52.33 10.5T221-608L92-478l198 198 130-129q20-21 30.5-46.54t10.5-52.25Q461-567 420.17-608q-40.84-41-100.34-41ZM277-465Zm402 103-28-28 56-56H570v-40h142l-60-60 28-28 106 106-107 106Z"
		/>
	</svg>
);
